import React from "react";
import { Button } from "@mui/material";
import axios from "axios";

const SaveButton = ({
  deletedAfms,
  newSigners,
  loading,
  setNotification,
  setLoading,
  signers,
}) => {
  const handleSave = async () => {
    const deleted_users = signers.filter((signer) => signer.isDeleted);

    const final_users = signers
      .map((signer) => {
        return (
          !deleted_users.some((del_user) => del_user.id === signer.id) && signer
        );
      })
      .filter(Boolean);

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/AadeData`,
        {
          final_users: final_users,
          deleted_users: deleted_users,
        },
        {
          withCredentials: true,
        },
      );
      setLoading(false);
      setNotification({
        open: true,
        color: "success",
        message: response.data.message,
      });
    } catch (error) {
      setLoading(false);
      setNotification({
        open: true,
        color: "error",
        message: error.response.data.message,
      });
    }
    setTimeout(() => {
      window.location.reload(false);
    }, 2000);
  };

  return (
    <>
      {deletedAfms &&
        newSigners &&
        (deletedAfms.length > 0 || newSigners.length > 0) && (
          <Button
            disabled={loading}
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Αποθήκευση
          </Button>
        )}
    </>
  );
};

export default SaveButton;
